<template>
  <div class="home">
    <NavbarComponent />
    <HeroComponent />
    <AboutMeComponent />
    <SkillsComponent />
    <ExperienceTimeline />
    <ProjectsComponent />
    <ContactComponent />
    <FooterComponent />
  </div>
</template>

<script>
import AboutMeComponent from "@/components/AboutMe.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import HeroComponent from "@/components/HeroComponent.vue";
import SkillsComponent from "@/components/SkillsComponent.vue";
import ContactComponent from "@/components/ContactComponent.vue";
import NavbarComponent from "@/components/NavbarComponent.vue";
import ProjectsComponent from "@/components/ProjectsComponent.vue";
import ExperienceTimeline from "@/components/ExperienceTimeline.vue";

export default {
  name: "HomeView",
  components: {
    NavbarComponent,
    AboutMeComponent,
    FooterComponent,
    HeroComponent,
    SkillsComponent,
    ContactComponent,
    ProjectsComponent,
    ExperienceTimeline,
  },
};
</script>

<style scoped>
.home {
  text-align: center;
}
</style>
